import { nowIsoAndUnix } from "@@/shared/date-time/iso-and-unix";
import { statusEventIdFactory } from "@@/shared/statuses/status-event-id";
import { statusEventZodObjectFactory } from "@@/shared/statuses/status-event-schema-factory";
import { z } from "zod";

const payloadZodObject = z
    .object({
        message: z.string().optional(),
    })
    .optional();

const { statusEventBaseZodObject, statusEventBaseFactoryParamsZodObject } =
    statusEventZodObjectFactory(z.literal("CHECK_IN__CHECKED_IN"));

const eventZodObject = statusEventBaseZodObject.merge(
    z.object({
        payload: payloadZodObject,
    }),
);

const _eventFactoryParamsZodObject =
    statusEventBaseFactoryParamsZodObject.merge(
        z.object({
            payload: payloadZodObject,
        }),
    );

type CheckIn_CheckedInEvent = z.infer<typeof eventZodObject>;
type FactoryParams = z.infer<typeof _eventFactoryParamsZodObject>;

const checkIn_checkedInEventFactory = (
    params: FactoryParams,
): CheckIn_CheckedInEvent => ({
    ...params,
    _id: statusEventIdFactory(),
    _createdAt: nowIsoAndUnix(),
    _type: "STATUS_EVENT",
    type: "CHECK_IN__CHECKED_IN",
});

export {
    checkIn_checkedInEventFactory,
    eventZodObject as checkIn_checkedInEventZodObject,
};
export type { CheckIn_CheckedInEvent };
